import { useState } from "react";
import { ReactComponent as ArrowIcon } from "../../../assets/icons/arrow-down-dropdown.svg";

const WorkersDropdown = ({ data }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);



  return (
    <div
      className={`global-category-dropdown dropdown-name data-status  ${
        dropdownOpen ? "active" : ""
      }`}
    >
      <div
        className="dropdown-head"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <h2>Bütün əməkdaşlar</h2>
        <div className="arrow-icon" style={{ marginLeft: "10px" }}>
          <ArrowIcon />
        </div>
      </div>

      <div className="dropdown-body">
        <ul>
          {data?.workers?.map((item) => (
            <li key={item.id}>{item.fullName}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default WorkersDropdown;
